import React from 'react';
import UnitReportFunctional from './components/unit-report-list-functional';
import './unit-report.scss';

const UnitReport = () => {
	return <UnitReportFunctional />;
};

export default UnitReport;
